/* template */
<template minapp="mpx" xlang="wxml"><div class="top-condition-bar"><template v-if="(!isTransfer)"><mpx-view @tap="clickFilter('tickets')" :class="({select: ticketsSelected})" class="top-condition-bar-item">只看有票</mpx-view><mpx-view @tap="clickFilter('speed')" :class="({select: speedSelected})" class="top-condition-bar-item">高铁动车</mpx-view></template><template v-else><mpx-view @tap="clickFilter('transferType')" :class="({select: transferTypeSelected})" class="top-condition-bar-item">同站换乘</mpx-view><mpx-view @tap="clickFilter('transferTrain')" :class="({select: transferGTrainSelected})" class="top-condition-bar-item">高铁中转</mpx-view></template><div class="split-line" v-if="(showSplitLine)"></div><mpx-view v-for="(item, index) in (from_station_list)" @tap="clickFilter('from', item)" :class="({select: fromSelected.includes(item)})" class="top-condition-bar-item">{{item}}</mpx-view><div class="split-line" v-if="(showSplitLine)"></div><mpx-view v-for="(item, index) in (to_station_list)" @tap="clickFilter('to', item)" :class="({select: toSelected.includes(item)})" class="top-condition-bar-item">{{item}}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m25fa1e73"}'>
  .top-condition-bar
    display flex
    flex-direction row
    padding-left 4px
    font-size 12px
    line-height 30px
    padding-bottom 12px
    overflow-x auto
    height 31px 
    white-space nowrap
    &-item
      height 30px
      border 0.5px solid #CCCCCC
      color #666666
      margin-left 8px
      border-radius 6px
      padding 0 10px
      width fit-content
      display flex
      flex-shrink 0
      // overflow hidden
    .select
      color #222222
      font-family PingFangSC-Medium
      border 0.5px solid #FF6400
      position relative
      &::after 
        content ''
        position absolute 
        bottom 0
        right 0
        width 10px
        height 10px
        background url('https://dpubstatic.udache.com/static/dpubimg/QbadIsbSV7H9PID73EIiG.png')
        background-size cover
    .split-line
      display flex
      flex-shrink 0
      margin 5px 0 0 8px
      width 0.5px
      height 20px
      background #CCCCCC
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m25fa1e73"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex25fa1e73%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex25fa1e73%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m25fa1e73"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index25fa1e73/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
